(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/xor', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/xor'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.xor, global.convert);
    global.xor = mod.exports;
  }
})(this, function (exports, _xor2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.xor = undefined;

  var _xor3 = _interopRequireDefault(_xor2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array by the symmetric difference of the former array and the given arrays.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} arrays The arrays to inspect.
   * @return {Object} Returns the updated object.
   * @example xor({ nested: { prop: [1, 2] } }, 'nested.prop', [2, 3]) // => { nested: { prop: [1, 3] } }
   * @see {@link https://lodash.com/docs#xor|lodash.xor} for more information.
   * @since 0.1.6
   */
  var xor = (0, _convert.convert)(_xor3.default);
  exports.xor = xor;
  exports.default = xor;
});